import styled from 'astroturf/react'
import { parseISOToDateTime } from '@calendly/datetime'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { formatDate } from '@calendly/booking-kit/services/time_format'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { BodyText } from '@calendly/ui/components/typography'

import { useI18n } from 'locales'

import SpotList from './spot_list'
import _Container from "day-Container.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/day.js?styleId=Container";
import _StyledSpotList from "day-StyledSpotList.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/day.js?styleId=StyledSpotList";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const StyledSpotList = /*#__PURE__*/styled(SpotList, null, {
  displayName: "StyledSpotList",
  styles: _StyledSpotList,
  attrs: props => ({
    ...props,
    isTablet: useDeviceType('isTabletUp')
  })
})

const Day = ({ day }) => {
  const { i18n } = useI18n()
  const dayDt = parseISOToDateTime(day.date)
  return (
    <Container data-day={formatDate(dayDt, i18n.t('time.formats.date_extra'))}>
      <FlexLayout direction="column" gap={8}>
        <BodyText as="div" weight="bold" size="medium">
          {formatDate(dayDt, i18n.t('time.formats.date_extra'))}
        </BodyText>
        <StyledSpotList day={day} />
      </FlexLayout>
    </Container>
  )
}

export default Day
